import styled from '@emotion/styled';
import { ITheme } from '../../../../../../ui';
import React from 'react';
import { IPrice } from '../../../../../shared/i18n/price/IPrice';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import themed from '../../../../../../ui/themer/themed';
import { BookingSummarySection } from './BookingSummarySection';

interface IOriginalAndNewTotalMobileProps {
	originalTotalPrice: IPrice;
	totalPrice: IPrice;
}

export const OriginalAndNewTotalMobile = ({
	originalTotalPrice,
	totalPrice,
}: IOriginalAndNewTotalMobileProps) => {
	const { t } = useTranslation();

	return (
		<StyledOriginalAndNewTotalMobile>
			<BookingSummarySection
				title={t('web_parking_booking_summary_old_total')}
				price={originalTotalPrice}
			/>

			<BookingSummarySection
				title={t('web_parking_booking_summary_new_total')}
				price={totalPrice}
			/>
		</StyledOriginalAndNewTotalMobile>
	);
};

export const StyledOriginalAndNewTotalMobile = styled.div<{}, ITheme>`
	display: flex;
	flex-direction: column;
	background: ${themed(({ background }) => background.light)};
`;
